import { getLangBundle } from './languageText';

export function getShareFallbackText(language?: string) {
  const bundle = getLangBundle(language);
  return {
    title: bundle.share_land_12,
    description: bundle.share_land_13,
    cta: bundle.share_land_14,
  };
}
